import dynamic from 'next/dynamic';
import { useContext, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { SearchContext, SearchContextInterface } from './context/SearchContext';
import { SearchFiltersActionTypes } from '../../reducers/search-filters/actions';
import useSearchResults from '../../hooks/SearchResults';
import { useRouter } from 'next/router';
import { initializeSearchFiltersFromQuery } from '../../helpers/search-filters';
const SearchView = dynamic(() => import('./SearchView'));
const MobileSearchView = dynamic(() => import('./MobileSearchView'));

interface SearchProps {
  loadedSearchResultsSSR: any;
  addQuery?: any;
}

const Search = ({ loadedSearchResultsSSR, addQuery }: SearchProps) => {
  const router = useRouter();

  const { searchFiltersDispatch, searchFiltersState } = useContext(
    SearchContext
  ) as SearchContextInterface;
  const searchBodyResults = useSearchResults(
    searchFiltersState.searchBody,
    loadedSearchResultsSSR
  );

  useEffect(() => {
    if (addQuery) {
      initializeSearchFiltersFromQuery(addQuery, searchFiltersDispatch);
    }
  }, []);

  const prevRoute = useSelector((state: any) => state.app.referer);
  useEffect(() => {
    if (prevRoute?.includes('/nawy-now')) {
      searchFiltersDispatch({
        type: SearchFiltersActionTypes.RESET
      });
    }
  }, [prevRoute]);
  const isMobile = useSelector((state: any) => state.app.isMobile);
  if (isMobile)
    return (
      <MobileSearchView
        resultsCount={searchBodyResults.loadedSearchResultsCount}
      />
    );
  else
    return (
      <SearchView
        loadedSearchResultsSSR={loadedSearchResultsSSR}
        resultsCount={searchBodyResults.loadedSearchResultsCount}
      />
    );
};

export default Search;
